// Central list of languages the public site is translated into. Adding a
// language means adding it here, dropping its files under public/locales/,
// and nothing else — routing, detection, and the switcher all read from this.
export const SUPPORTED_LANGUAGES = ['en', 'es'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
};

export function isSupportedLanguage(value: string | undefined): value is SupportedLanguage {
  return !!value && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

// Matches i18next-browser-languagedetector's own navigator lookup (reads
// navigator.languages, falling back to navigator.language/userLanguage), then
// maps the result onto a language we actually ship. This is what "follow the
// user's system settings" means in practice: whatever the OS/browser reports.
export function detectPreferredLanguage(): SupportedLanguage {
  if (typeof navigator === 'undefined') return DEFAULT_LANGUAGE;
  const candidates = navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language];
  for (const candidate of candidates) {
    if (!candidate) continue;
    const base = candidate.split('-')[0].toLowerCase();
    if (isSupportedLanguage(base)) return base;
  }
  return DEFAULT_LANGUAGE;
}
